import React from 'react';

import l10n from "../../../l10n/localization";
import Loader from "../../common/Loader";
import * as costActions from "../../../actions/cost";
import {connect} from "react-redux";
import {Table} from "react-materialize";
import CostItem from "./CostItem";

class CostTable extends React.Component {

    componentDidMount() {
        this.props.dispatch(costActions.fetchCosts(this.props.fog.id, true));
    }

    calculateCostSum() {
        let result = 0;
        this.props.costs.forEach((item) => {
            result += item.totalCost;
        });
        return result;
    }

    render() {
        var costSum = this.calculateCostSum();

        if (this.props.loading || this.props.costs === undefined) {
            return (<div><Loader /></div>)
        }

        return (
            <div>
                <table className="cargo-summary">
                    <thead>
                    <tr>
                        <td>
                            {l10n.costSummary.value}
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            {!isNaN(costSum) && costSum.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                    </tr>
                    </tbody>
                </table>


                <Table bordered>
                    <thead>
                        <tr>
                            <th data-field="company">{l10n.cost.company}</th>
                            {/*<th data-field="currency">{l10n.cost.currency}</th>*/}
                            <th data-field="creationDate">{l10n.cost.creationDate}</th>
                            <th data-field="invoiceNumber">{l10n.cost.invoiceNumber}</th>
                            <th data-field="label">{l10n.cost.label}</th>
                            <th data-field="totalCost">{l10n.cost.totalCost}</th>
                            <th data-field="actions">{l10n.common.actions}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.props.costs.map((item, index) => (
                            <CostItem item={item} key={index} openDrawer={this.props.openDrawer} fog={this.props.fog} depth={this.props.depth + 1} currency={this.props.currency}/>
                        ))}
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        costs: state.cost.costs,
        loading: state.cost.loading,
    });
})(CostTable);


// WEBPACK FOOTER //
// ./src/components/fog/cost/CostTable.js